export enum FunnelEntryType {
  Instagram = 'Instagram',
  TikTok = 'TikTok',
}

export enum FunnelStatus {
  Successful = 'SUCCESSFUL',
  Failed = 'FAILED',
  Unchecked = 'UNCHECKED',
}

export interface FunnelCheck {
  id: number
  entryPointType: FunnelEntryType
  entryPointData: string
  goesThroughInstagram: boolean
  goalUrl: string
  lastCheckedAt: string
  status: FunnelStatus
  disabled: boolean
  failInfo: string | null
  avatarUrl: string | null
}

export interface FunnelCheckCreate {
  entryPointType: FunnelEntryType
  entryPointData: string
  goesThroughInstagram: boolean
  goalUrl: string
}

export type FunnelCheckEdit = Partial<FunnelCheckCreate>
